import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import {CategoryData } from "types/models/planMaster/planMasterApp";


const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 8,
  minWidth:170,
  "&:first-of-type": {
    paddingLeft: 20,
  },
  "&:last-of-type": {
    paddingRight: 20,
  },
}));

interface TableItemProps {
  data: CategoryData;
}

  const TableItem: React.FC<TableItemProps> = ({ data }) => {   
    const getStatusColor = () => {
      if (data.status) {
        return "#43C888"; 
      } else {
        return "#F84E4E"; 
      }
  }  
  return (
    <TableRow key={data.sNo} className="item-hover">
      <StyledTableCell component="th" scope="row">
        <Box
          sx={{
            color: "black", 
            borderBottom: "none",
            display: "inline-block",
          }}
        >
          {data.sNo}
        </Box>
      </StyledTableCell>
      <StyledTableCell align="left">{data.categoryName}</StyledTableCell>
      <StyledTableCell align="left">{data.categoryIndex}</StyledTableCell>
      <StyledTableCell align="left">{data.categoryUrl}</StyledTableCell>
      <StyledTableCell align="left">
        <Box
          sx={{
            color: getStatusColor(),
            backgroundColor: getStatusColor() + "44",
            padding: "3px 5px",
            borderRadius: 1,
            fontSize: 14,
            display: "inline-block",
          }}
        >
          {data.status}
        </Box>
      </StyledTableCell>
    </TableRow>
  );
};

export default TableItem;
